import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import {
  FiHome,
  FiPackage,
  FiList,
  FiFileText,
  FiSettings,
  FiMoreHorizontal,
  FiLogOut,
  FiPieChart,
  FiDollarSign,
  FiUsers,
  FiTool,
  FiX,
} from "react-icons/fi";

const tabs = [
  { path: "/dashboard", icon: FiHome, label: "Dashboard" },
  { path: "/subscriptions", icon: FiPackage, label: "Plans" },
  { path: "/transactions", icon: FiList, label: "Payments" },
  { path: "/invoices", icon: FiFileText, label: "Invoices" },
  { path: "/settings", icon: FiSettings, label: "Settings" },
];

const adminItems = [
  { path: "/admin", icon: FiPieChart, label: "Overview", end: true },
  { path: "/admin/pricing", icon: FiDollarSign, label: "Subscriptions" },
  { path: "/admin/users", icon: FiUsers, label: "Users" },
  { path: "/admin/integrations", icon: FiTool, label: "Integrations" },
];

function BottomTabBar({ isAdmin }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [showMore, setShowMore] = useState(false);

  const handleMoreNavigate = (path) => {
    setShowMore(false);
    navigate(path);
  };

  return (
    <>
      <nav className="bottom-tab-bar">
        {tabs.map(({ path, icon: Icon, label }) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) =>
              `bottom-tab-item ${isActive ? "active" : ""}`
            }
            onClick={() => setShowMore(false)}
          >
            <Icon className="bottom-tab-icon" />
            <span className="bottom-tab-label">{label}</span>
          </NavLink>
        ))}

        <button
          className={`bottom-tab-item ${showMore ? "active" : ""}`}
          onClick={() => setShowMore(!showMore)}
        >
          <FiMoreHorizontal className="bottom-tab-icon" />
          <span className="bottom-tab-label">More</span>
        </button>
      </nav>

      {showMore && (
        <div className="modal-overlay" onClick={() => setShowMore(false)}>
          <div
            className="modal more-sheet"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <div className="modal-title">More</div>
              <button
                className="modal-close"
                onClick={() => setShowMore(false)}
                aria-label="Close"
              >
                <FiX />
              </button>
            </div>

            {isAdmin && (
              <>
                <div className="nav-section-title">Administration</div>
                {adminItems.map(({ path, icon: Icon, label }) => (
                  <button
                    key={path}
                    className="nav-item more-sheet-item"
                    onClick={() => handleMoreNavigate(path)}
                  >
                    <Icon />
                    {label}
                  </button>
                ))}
              </>
            )}

            <button
              className="nav-item more-sheet-item"
              onClick={() => {
                setShowMore(false);
                logout();
              }}
            >
              <FiLogOut />
              Logout
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default BottomTabBar;
